<div class="grid-container">
  <div class="cards-container">
    <img
      class="device-suspended__icon"
      src="assets/device-suspended.svg"
      alt="Device Suspended Icon"
    />
    <p class="text" data-testid="device-suspended-msg">
      {{ 'common.killSwitchSuspendedMsg' | translate }}
    </p>
  </div>
</div>
